import Modal from "react-bootstrap/Modal";
import {Button, ModalBody, ModalFooter} from "react-bootstrap";
import {useTranslation} from "react-i18next";

function ChangeVideoModal(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'changeVideoModal' });
    return (
        <>
            <Modal
                show={true}
                onHide={props.closeModal}
            >
                <ModalBody style={{fontSize: "24px"}}>
                    {t('switchVideoTypeQ')}
                    <br></br>
                    <span style={{fontSize: "18px"}}>
                    <b>{t('pageReloadsAutomatically')}</b></span>
                </ModalBody>
                <ModalFooter>
                    <Button style={{backgroundColor: "red", borderColor: "red"}} onClick={props.closeModal}>{t('noButton')}</Button>
                    <Button style={{backgroundColor: "green", borderColor: "green"}} onClick={props.changeVideo}>{t('yesButton')}</Button>
                </ModalFooter>
            </Modal>
        </>
    )
}
export default ChangeVideoModal